import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { catchError, finalize, of, tap } from 'rxjs';
import { AuthService } from '@anihis/core/data-access';
import { LoadingStatus } from '../../shared/enums/loading';

type RestoreClinicState = {
  status: LoadingStatus;
  error: string | null;
};

const initialState: RestoreClinicState = {
  status: LoadingStatus.Loading,
  error: null,
};

export const RestoreClinicStore = signalStore(
  withState(initialState),
  withMethods((store, authService = inject(AuthService), router = inject(Router)) => ({
    restoreClinic(clinicUid: string, token: string) {
      patchState(store, { status: LoadingStatus.Loading, error: null });

      return authService.authRestoreClinicPost({ clinicUid, token }).pipe(
        tap(() => {
          patchState(store, { status: LoadingStatus.Loaded });
          router.navigateByUrl('/login');
        }),
        catchError((err) => {
          const errorMessage =
            err?.error?.message ||
            err?.error?.title ||
            err?.error ||
            'An error occurred. Please try again.';
          patchState(store, {
            status: LoadingStatus.Error,
            error:
              typeof errorMessage === 'string'
                ? errorMessage
                : JSON.stringify(errorMessage),
          });
          return of(null);
        }),
        finalize(() => {}),
      );
    },
  })),
);
